import * as _ from 'lodash'
import AmpersandView from 'ampersand-view'

const Registry = function Registry() {}

Registry.prototype.views = {}
Registry.prototype.xhrs = []

Registry.prototype.store = function(objs) {
  objs = _.isArray(objs) ? objs : [objs]
  objs.forEach((obj) => {
    switch (false) {
      case !(obj instanceof AmpersandView):
        this.storeView(obj)
        break
      case !(obj instanceof XMLHttpRequest):
        this.storeXhr(obj)
        break
    }
  })
}

Registry.prototype.remove = function(objs) {
  objs = _.isArray(objs) ? objs : [objs]
  objs.forEach((obj) => {
    switch (false) {
      case !(obj instanceof AmpersandView):
        this.removeView(obj)
        break
      case !(obj instanceof XMLHttpRequest):
        this.removeXhr(obj)
        break
    }
  })
}

Registry.prototype.storeView = function(view) {
  const type = view.constructor.name
  this.views[type] = this.views[type] || []
  this.views[type].push(view)
}

Registry.prototype.removeView = function(view) {
  const type = view.constructor.name
  _.remove(this.views[type], (n) => n.cid === view.cid)
  if (this.views[type] && !this.views[type].length) {
    delete this.views[type]
  }
}

Registry.prototype.storeXhr = function(xhr) {
  const onreadystatechange = xhr.onreadystatechange
  xhr.onreadystatechange = () => {
    xhr.readyState === 4 && this.remove(xhr)
    onreadystatechange()
  }
  this.xhrs.push(xhr)
}

Registry.prototype.removeXhr = function(xhr) {
  const index = this.xhrs.indexOf(xhr)
  if (index > -1) {
    this.xhrs.splice(index, 1)
  }
}

// abort requests that are not marked as concurrent
Registry.prototype.abortXhr = function(xhr) {
  this.xhrs.forEach((x) => {
    if ((!xhr || x === xhr) && !x.isConcurrent) {
      x.aborted = true
      x.abort()
    }
  })
}

export default Registry
